// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._8fbc3Ny0jb6BZ5D2eILmjA\\=\\= {\n  margin-top: 16px;\n}\n\n.zxDgIU5JmOxo\\+BzH4l24Yg\\=\\= {\n  margin-top: 10px;\n}", "",{"version":3,"sources":["webpack://./src/content/styles/LessonComponentSubmissionPanel.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".submissionPanel {\n  margin-top: 16px;\n}\n\n.points {\n  margin-top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"submissionPanel": "_8fbc3Ny0jb6BZ5D2eILmjA==",
	"points": "zxDgIU5JmOxo+BzH4l24Yg=="
};
export default ___CSS_LOADER_EXPORT___;
